import backSlimArr from './backSlimArrow.svg';

const sidebarIcons = {
  backSlimArr,
};

export default sidebarIcons;
